import type { QueryClient } from "@tanstack/react-query";
import { QUERY_KEYS } from "@config/constant";

export type InvalidateChatDetailOptions = {
  /** 为 true 时不向其它 WebView 广播（接收中继广播时使用） */
  skipCrossWebViewBroadcast?: boolean;
  /** 同时失效会话列表（如流式结束、新建会话后） */
  includeHistory?: boolean;
};

/**
 * 本地 invalidate 全部 CHAT_DETAIL + 可选跨 WebView 广播
 */
export function invalidateChatDetailQueries(
  queryClient: QueryClient,
  _chatId?: string,
  options?: InvalidateChatDetailOptions,
): void {
  void queryClient.invalidateQueries({
    queryKey: [QUERY_KEYS.CHAT_DETAIL],
  });
  if (options?.includeHistory) {
    void queryClient.invalidateQueries({
      queryKey: [QUERY_KEYS.CHAT_HISTORY],
    });
  }
}

/**
 * 重置指定会话的详情分页缓存，清除 startId 游标，下次打开从最新一页拉取。
 */
export function resetChatDetailPagination(
  queryClient: QueryClient,
  chatId: string,
): void {
  void queryClient.resetQueries({
    queryKey: [QUERY_KEYS.CHAT_DETAIL, chatId],
    exact: true,
  });
}
